import {
  useAssignSetting,
  useSetting,
} from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { FE_BATCH_12_BRAND_PAGES_250811 } from "@faire/retailer-settings/FE_BATCH_12_BRAND_PAGES_250811";
import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";

export const useSettingBatch12BrandPage = (): IThreeVariantXP.Bucket =>
  useSetting(FE_BATCH_12_BRAND_PAGES_250811);

export const useAssignSettingBatch12BrandPage = () =>
  useAssignSetting(FE_BATCH_12_BRAND_PAGES_250811);
